import { ReactComponent as FlagIcon } from "./svg/mx-flag.svg";
import "../flag-icon.scss";

export const MXFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
